import React, { Component } from 'react'
import Dialog from 'material-ui/Dialog'
import RaisedButton from 'material-ui/RaisedButton'


const blueColor= 'rgb(34, 154, 168)' //#229aa8


class DialogInfo extends Component {
  state = {
    open: true,
  }

  handleOpen = () => this.setState({open: true})
  handleClose = () => this.setState({open: false})

  render() {

    return (
      <div style={{width:'100%'}}>


        <Dialog
          contentStyle={{width:'100%',maxWidth:600,height:'90vh'}}
          title="⚠ Application en maintenance ⚠"
          modal={false}
          autoScrollBodyContent={true}
          open={this.state.open}
          onRequestClose={this.handleClose}>

<p style={{marginTop:20,marginBottom:20}}>
          Assalamaleykom warahmathullah wabarakathuhu, <br/>
          L'application horaire de prière est actuellement en maintenance mais reste disponible.
          Veuillez nous excusez pour la gène occasionnée. Nous faisons notre maximum pour corriger les dysfonctionnements dus à une surcharge de connexion.
          Barakallahufikom.
</p>
          <RaisedButton
       label="OK"
       primary={true}
       onClick={this.handleClose}
     />
        </Dialog>



      </div>
    )
  }

}

export default DialogInfo



// WEBPACK FOOTER //
// ./src/components/DialogInfo.jsx